var ohm = require('..');

module.exports = ohm.makeRecipe(["grammar", {
  "source": "BuiltInRules {\n\n  alnum  (an alpha-numeric character)\n    = letter\n    | digit\n\n  letter  (a letter)\n    = lower\n    | upper\n    | unicodeLtmo\n\n  digit  (a digit)\n    = \"0\"..\"9\"\n\n  hexDigit  (a hexadecimal digit)\n    = digit\n    | \"a\"..\"f\"\n    | \"A\"..\"F\"\n\n  ListOf<elem, sep>\n    = NonemptyListOf<elem, sep>\n    | EmptyListOf<elem, sep>\n\n  NonemptyListOf<elem, sep>\n    = elem (sep elem)*\n\n  EmptyListOf<elem, sep>\n    = /* nothing */\n\n  listOf<elem, sep>\n    = nonemptyListOf<elem, sep>\n    | emptyListOf<elem, sep>\n\n  nonemptyListOf<elem, sep>\n    = elem (sep elem)*\n\n  emptyListOf<elem, sep>\n    = /* nothing */\n\n}"
}, "BuiltInRules", null, null, {
  "alnum": ["define", {
    "sourceInterval": [18, 78]
  }, "an alpha-numeric character", [], ["alt", {
    "sourceInterval": [60, 78]
  }, ["app", {
    "sourceInterval": [60, 66]
  }, "letter", []], ["app", {
    "sourceInterval": [73, 78]
  }, "digit", []]]],
  "letter": ["define", {
    "sourceInterval": [82, 142]
  }, "a letter", [], ["alt", {
    "sourceInterval": [107, 142]
  }, ["app", {
    "sourceInterval": [107, 112]
  }, "lower", []], ["app", {
    "sourceInterval": [119, 124]
  }, "upper", []], ["app", {
    "sourceInterval": [131, 142]
  }, "unicodeLtmo", []]]],
  "digit": ["define", {
    "sourceInterval": [146, 177]
  }, "a digit", [], ["range", {
    "sourceInterval": [169, 177]
  }, "0", "9"]],
  "hexDigit": ["define", {
    "sourceInterval": [181, 254]
  }, "a hexadecimal digit", [], ["alt", {
    "sourceInterval": [219, 254]
  }, ["app", {
    "sourceInterval": [219, 224]
  }, "digit", []], ["range", {
    "sourceInterval": [231, 239]
  }, "a", "f"], ["range", {
    "sourceInterval": [246, 254]
  }, "A", "F"]]],
  "ListOf": ["define", {
    "sourceInterval": [258, 336]
  }, null, ["elem", "sep"], ["alt", {
    "sourceInterval": [282, 336]
  }, ["app", {
    "sourceInterval": [282, 307]
  }, "NonemptyListOf", [["param", {}, 0], ["param", {}, 1]]], ["app", {
    "sourceInterval": [314, 336]
  }, "EmptyListOf", [["param", {}, 0], ["param", {}, 1]]]]],
  "NonemptyListOf": ["define", {
    "sourceInterval": [340, 388]
  }, null, ["elem", "sep"], ["seq", {
    "sourceInterval": [372, 388]
  }, ["param", {}, 0], ["star", {
    "sourceInterval": [377, 388]
  }, ["seq", {
    "sourceInterval": [378, 386]
  }, ["param", {}, 1], ["param", {}, 0]]]]],
  "EmptyListOf": ["define", {
    "sourceInterval": [392, 434]
  }, null, ["elem", "sep"], ["seq", {
    "sourceInterval": [438, 438]
  }]],
  "listOf": ["define", {
    "sourceInterval": [438, 516]
  }, null, ["elem", "sep"], ["alt", {
    "sourceInterval": [462, 516]
  }, ["app", {
    "sourceInterval": [462, 487]
  }, "nonemptyListOf", [["param", {}, 0], ["param", {}, 1]]], ["app", {
    "sourceInterval": [494, 516]
  }, "emptyListOf", [["param", {}, 0], ["param", {}, 1]]]]],
  "nonemptyListOf": ["define", {
    "sourceInterval": [520, 568]
  }, null, ["elem", "sep"], ["seq", {
    "sourceInterval": [552, 568]
  }, ["param", {}, 0], ["star", {
    "sourceInterval": [557, 568]
  }, ["seq", {
    "sourceInterval": [558, 566]
  }, ["param", {}, 1], ["param", {}, 0]]]]],
  "emptyListOf": ["define", {
    "sourceInterval": [572, 614]
  }, null, ["elem", "sep"], ["seq", {
    "sourceInterval": [616, 616]
  }]]
}]);